import { ClassHelper } from 'components/lib';
import Style from './legend.tailwind.js';

interface LegendProps {
  className?: string;
  required?: boolean;
  valid?: boolean;
  text?: string;
}

export function Legend(props: LegendProps) {
  const css = ClassHelper(Style, {
    className: props.className,
    required: props.required,
    error: !props.valid,
  });

  return (
    <legend className={css} dangerouslySetInnerHTML={{ __html: props.text ?? '' }}>
      {/* {props.text} */}
    </legend>
  );
}
